import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import Menu1 from "../components/Home/Menu1";
import { TextField } from "@mui/material";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
} from "@mui/material";
import useWindowDimensions from "../CustomHooks/useWindowdimension";
import Button1 from "../components/ResubleComp/Button";
const Next2LoginPage = () => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("TOKEN");

  const [domainExpertise, setDomainExpertise] = useState([]);
  const [sessionPrice, setPrice] = useState("");
  const [domainBio, setdomainBio] = useState("");
  const [userid, setuserid] = useState("");
  const [Loading, setLoading] = useState(false);
  const { height, width } = useWindowDimensions();

  const clickHandler = async () => {
    const url = baseUrl + `/api/user/profile`;
    const dataa = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    const result = await dataa.json();
    setuserid(result);
  };
  useEffect(() => {
    clickHandler();
  }, []);

  const submitHandler = async () => {
    setLoading(true);
    const URL = baseUrl + `/api/user/profile/${userid._id}`;
    const data = {
      sessionPrice: sessionPrice,
      domainExpertise: domainExpertise,
      domainBio: domainBio,
    };
    const updateDataresponse = await axios.put(URL, data, {
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    setLoading(false);
    if (updateDataresponse.status === 201) {
      // navigate("/userprofile");
      navigate("/thankyou");
    }
    console.log("updateDataresponsetwofield", domainExpertise);
  };
  return (
    <div className="flex justify-center items-center mt-10">
      <div className="flex flex-col items-center lg:bg-gradient-to-bl bg-white lg:shadow-xl rounded-xl px-3 py-3 mx-3 w-[95%] lg:w-1/3 md:w-1/3 my-28">
        <h3 className="font-semibold lg:text-[20px] mb-5 text-[20px]">
          Fill your details
        </h3>
        <div className="flex flex-col w-full">
          <div className="px-2">
            <label
              className="block text-gray-700 text-xs font-bold mb-2 mt-1"
              htmlFor="email"
            >
              Mobile Number <span className="text-red-600">*</span>
            </label>
            <TextField
              id="outlined-basic"
              label="Mobile Number"
              variant="outlined"
              fullWidth
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*", // Optional: additional pattern validation to allow only numbers
              }}
            />
            <label
              className="block text-gray-700 text-xs font-bold mb-2 mt-1"
              htmlFor="email"
            >
              Choose your Topic/Subject <span className="text-red-600">*</span>
            </label>
            <Menu1
              domainExpertise={domainExpertise}
              setDomainExpertise={setDomainExpertise}
            />
            <label
              className="block text-gray-700 text-xs font-bold mb-2 mt-1"
              htmlFor="email"
            >
              Domain expertise <span className="text-red-600">*</span>
            </label>
            <TextareaAutosize
              autoFocus
              minRows={4}
              name="domainBio"
              maxLength={200}
              placeholder="Tell us about your domain experience/expertise. It will help us in verification. Also, tell us about what you want to teach here."
              style={{
                width: width > 768 ? "100%" : width > 450 ? "100%" : "100%",
                paddingLeft: "10px",
                paddingTop: "5px",
                border: "2px solid #EAE0DA",
              }}
              label="domainBio"
              id="fullWidth"
              value={domainBio}
              onChange={(e) => setdomainBio(e.target.value)}
            />
          </div>

          <div className="px-2">
            {/* <FormControl sx={{ ml: 1, mt: 2 }} className="w-full"> */}
            {/* <span className="block text-gray-700 text-xs font-bold mb-2">Choose your price for a single session</span> */}
            {/* <InputLabel className="block text-gray-700 text-xs font-bold mb-2" id="demo-multiple-name-label" label="Choose your price for a single session " >
              Choose your price for a single session
              </InputLabel> */}
            {/* <Select
                name="typeofuser"
                value={sessionPrice}
                onChange={(e) => setPrice(e.target.value)}
                labelId="demo-multiple-name-label"
                className="w-full mt-2"
              >
                <MenuItem value="49">49 </MenuItem>
                <MenuItem value="99">99</MenuItem>
                <MenuItem value="199">199</MenuItem>
                <MenuItem value="299">299</MenuItem>
                <MenuItem value="399">399</MenuItem>
                <MenuItem value="499">499</MenuItem>
              </Select> */}
            {/* </FormControl> */}
          </div>

          <div className="">
            <Button1
              primary
              className="hover:bg-gray-200 hover:text-black text-black font-medium py-4 rounded lg:w-full md:full w-full text-sm mt-5"
              onClick={submitHandler}
            >
              Submit {Loading && <CircularProgress />}
            </Button1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Next2LoginPage;
